import { useEffect, useState } from 'react';

const WithScrollHeader = ({ children }) => {
  const [isTop, setIsTop] = useState(true);

  const handleScroll = () => setIsTop(!(window.pageYOffset > 0));

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`${!isTop ? 'bg-white ' : ''}border-b border-solid border-gray-30 sticky top-0 z-10`}>
      {children}
    </header>
  );
};

export default WithScrollHeader;
